<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p54"><span><a id="page_41"></a><a href="#/Contents#rp54">GINGER PUMPKIN SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Substitute 2½ cups canned pumpkin if you can’t get a fresh pumpkin.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1 small pumpkin, peeled, seeded, cubed</span></p>
<p class="hang"><span>1 cup chopped onion</span></p>
<p class="hang"><span>1 tablespoon chopped gingerroot</span></p>
<p class="hang"><span>1 teaspoon minced garlic</span></p>
<p class="hang"><span>3 cups Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>½ cup dry white wine or Chicken Stock</span></p>
<p class="hang"><span>½ teaspoon ground cloves</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except salt and pepper, to boiling in large saucepan; reduce heat and simmer, covered, until pumpkin is tender, about 20 minutes. Process soup in food processor or blender until smooth. Return to saucepan and heat until hot; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 83</span></p>
<p class="per1"><span>% calories from fat: 6</span></p>
<p class="per1"><span>Protein (g): 2.8</span></p>
<p class="per1"><span>Carbohydrate (g): 15.3</span></p>
<p class="per1"><span>Fat (g): 0.6</span></p>
<p class="per1"><span>Saturated fat (g): 0.2</span></p>
<p class="per1"><span>Cholesterol (mg): 1.7</span></p>
<p class="per1"><span>Sodium (mg): 8</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0235.vue?ea7acc60